/**
 * The card. Two grounds only: `raised` for things that carry a value or an
 * action, `surface` for panels that hold a list or a log.
 */
const SurfaceCard = ({
  children,
  tone = 'raised',
  radius = 'card',
  className = '',
  elevated = false,
}: {
  children: React.ReactNode,
  tone?: 'raised' | 'surface',
  radius?: 'card' | 'container',
  /** The one shadow the system uses, reserved for the status banner. */
  elevated?: boolean,
  className?: string,
}) => (
  <div
    className={[
      tone === 'raised' ? 'bg-navy-700' : 'bg-navy-800',
      radius === 'card' ? 'rounded-card' : 'rounded-container',
      'border border-navy-500',
      elevated ? 'shadow-[0_1px_2px_rgba(0,0,0,.4),0_2px_4px_rgba(0,0,0,.3)]' : '',
      className,
    ].join(' ')}
  >
    {children}
  </div>
)

export default SurfaceCard
